import { Badge, Group, Pagination, Table } from "@mantine/core";
import * as C from "../../../../../../ui/common/CommonStyles";
import {
  getLanguage,
  getNoticeType,
  getSolution,
} from "../../../../../../../shared/constants/commonCode";
import { handleChangeLocaleTime } from "../../../../../../../shared/utils/time";
import { useNavigate } from "react-router-dom";
import { INoticeList } from "../../types";
import useNotices from "../hooks/useNotices";
import { useSearchFilters } from "../../../../../../../shared/hook/useSearchFilter";

const tableHead = [
  "번호",
  "솔루션",
  "공지 유형",
  "제목",
  "언어",
  "대표 여부",
  "작성자",
  "수정일자",
];

export default function NoticeListTable() {
  const navigate = useNavigate();
  const initSearchType = "title";

  const {
    page,
    size,
    solutionFilter,
    noticeTypeFilter,
    searchWord,
    updateFilters,
  } = useSearchFilters({
    initType: initSearchType,
  });

  const { noticeList } = useNotices({
    queryKey: [
      "getNoticeList",
      page,
      solutionFilter,
      noticeTypeFilter,
      searchWord,
    ],
    payload: {
      page: Number(page),
      size: Number(size),
      search: {
        title: searchWord || "",
      },
      filter: {
        solutionCd: solutionFilter === "all" ? "" : solutionFilter,
        noticeCd: noticeTypeFilter === "all" ? "" : noticeTypeFilter,
      },
    },
  });

  return (
    <>
      <C.TableWrap>
        <Table.ScrollContainer minWidth={1200}>
          <Table withTableBorder>
            <Table.Thead>
              <Table.Tr>
                {tableHead.map((head, index) => (
                  <Table.Th key={index}>{head}</Table.Th>
                ))}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {noticeList.result.length > 0 ? (
                noticeList.result.map((item: INoticeList, index: number) => (
                  <Table.Tr key={item.noticeId}>
                    <Table.Td>
                      {Number(page) === 1
                        ? index + 1
                        : (Number(page) - 1) * 10 + index + 1}
                    </Table.Td>
                    <Table.Td>{getSolution(item.solutionCd)}</Table.Td>
                    <Table.Td>{getNoticeType(item.noticeCd)}</Table.Td>
                    <Table.Td
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate(`/admin/edgecross/notice/${item.noticeId}`)
                      }
                    >
                      {item.title}
                    </Table.Td>
                    <Table.Td>{getLanguage(item.languageCd)}</Table.Td>
                    <Table.Td>
                      {item.isPinned && (
                        <Badge variant="light" size="md" color="secondary.5">
                          대표글
                        </Badge>
                      )}
                    </Table.Td>
                    <Table.Td>{item.modUserName}</Table.Td>
                    <Table.Td>{handleChangeLocaleTime(item.modDate)}</Table.Td>
                  </Table.Tr>
                ))
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={tableHead.length}>
                    조회된 결과가 없습니다.
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </C.TableWrap>
      <Group justify="center" mt="md">
        <Pagination
          total={Math.ceil(noticeList.count / Number(size))}
          value={Number(page)}
          onChange={(value) => {
            updateFilters({
              page: String(value),
            });
          }}
        />
      </Group>
    </>
  );
}
